import EditLicenseModal from 'components/EditLicenseModal'
import EditProductUserModal from 'components/EditProductUserModal'
import EditTrainingModal from 'components/EditTrainingModal'
import RemoveUserTraining from 'components/RemoveUserTrainingModal'

export const modalMap = {
  editLicense: {
    component: EditLicenseModal,
    size: 'lg',
  },
  editProductUserModal: {
    component: EditProductUserModal,
  },
  editTrainingModal: {
    component: EditTrainingModal,
    size: 'lg',
  },
  removeUserTrainingModal: {
    component: RemoveUserTraining,
  },
}
